import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import isNil from 'lodash/isNil'
import { useTranslation } from 'react-i18next'
import { CustomRenderColumnConfig } from '@omnea-app/fe-tables/columns/definitions/getCustomRenderColumn'
import { TextColumnConfig } from '@omnea-app/fe-tables/columns/definitions/getTextColumn'
import { PriceDisplay } from '@omnea-app/frontend/components/shared/ui/price/PriceDisplay'
import { RequestRow } from '../useRequestTableRows'

interface UseRemotePOColumnsProps {
  sortable?: boolean
}

export const useRemotePOColumns = ({
  sortable = true,
}: UseRemotePOColumnsProps): (CustomRenderColumnConfig<RequestRow> | TextColumnConfig<RequestRow>)[] => {
  const { t } = useTranslation('requests')

  return [
    {
      columnType: 'custom-render' as const,
      field: 'remotePOInvoicedValue' as const,
      type: 'number' as const,
      sortable,
      headerName: t('table-column.remotePOInvoicedValue'),
      valueGetter: (_: unknown, row: RequestRow) => {
        const amount = row.remotePOInvoicedValue
        if (isNil(amount)) return null
        return amount
      },
      renderCell: (params: GridRenderCellParams<RequestRow>) => {
        const amount = params.row.remotePOInvoicedValue
        const currency = params.row.remoteCurrency
        if (isNil(amount)) return null
        if (isNil(currency)) return amount
        return (
          <PriceDisplay
            price={{
              amount,
              currency,
            }}
            direction="column"
          />
        )
      },
    },
    {
      columnType: 'custom-render' as const,
      field: 'remotePOPaidValue' as const,
      type: 'number' as const,
      sortable,
      headerName: t('table-column.remotePOPaidValue'),
      valueGetter: (_: unknown, row: RequestRow) => {
        const amount = row.remotePOPaidValue
        if (isNil(amount)) return null
        return amount
      },
      renderCell: (params: GridRenderCellParams<RequestRow>) => {
        const amount = params.row.remotePOPaidValue
        const currency = params.row.remoteCurrency
        if (isNil(amount)) return null
        if (isNil(currency)) return amount
        return (
          <PriceDisplay
            price={{
              amount,
              currency,
            }}
            direction="column"
          />
        )
      },
    },
    {
      columnType: 'text' as const,
      field: 'remotePOStatus' as const,
      sortable,
      headerName: t('table-column.remotePOStatus'),
      valueGetter: (_: unknown, row: RequestRow) => row.remotePOStatus ?? null,
    },
    {
      columnType: 'custom-render' as const,
      field: 'remotePOTotalValue' as const,
      type: 'number' as const,
      sortable,
      headerName: t('table-column.remotePOTotalValue'),
      valueGetter: (_: unknown, row: RequestRow) => {
        const amount = row.remotePOTotalValue
        if (isNil(amount)) return null
        return amount
      },
      renderCell: (params: GridRenderCellParams<RequestRow>) => {
        const amount = params.row.remotePOTotalValue
        const currency = params.row.remoteCurrency
        if (isNil(amount)) return null
        if (isNil(currency)) return amount
        return (
          <PriceDisplay
            price={{
              amount,
              currency,
            }}
            direction="column"
          />
        )
      },
    },
  ]
}
